module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cmn.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "right1b"
  }, [_vm._v("Works of art change the course of history!")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("—Karlheinz Stockhausen"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_1",
      "id": "fn_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "span1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCIANO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIO SAID")]), _vm._v(" the following of the harp, as played by French American harpist Carlos Salzedo (1883–1961): “Traditionally, the harp is a feminine instrument: one always imagines a beautiful girl with Melisande-like hair, half naked and concealed behind trees in the mist, stroking the strings … Aeolian harps, Sappho … but Salzedo’s playing technique has made me relinquish that poetic imagery: with him, the harp becomes a richer and more powerful instrument. Is it a feminine instrument?—that may well be, but wielded by a strong, earthly woman, one made free.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_2",
      "id": "fn_2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is true that the harp is inevitably associated with that romantic image of silky glissandi, rippling chords, and a drawing-room repertoire. Yet that is only one of its many facets. The harp is present in every type of repertoire—in the theatre, in jazz, and in improvisation. The noise made by the pedals, the impacts, fingernails—such crackling and grinding sounds become expressive elements of the musical discourse. Harpists pinch, scratch, rub, hit, tear, stroke, speak, sing, whistle, and whisper. They use screwdrivers, erasers, papers, sticks, bows, bottle tops, and pegs. They sit or stand at the side of, behind, or in front of their instrument, and they explore not only the strings but also the sound box, the soundboard, the tuning pins, and the pedals, and so on. The harp may be scheming and then violent, frivolous, seductive, serious, meditative, somber, merry, playful, mischievous, or rebellious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“What we play is life,” states Louis Armstrong.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("According to Ivane Béatrice Bellocq, “Harpists search out new territories, sometimes completely immersing themselves in them, thus opening the way to a whole new repertoire and, even more valuably, to a real creation culture.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_3",
      "id": "fn_3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, the influence of imaginative harpists and their collaborations with composers have led to new perspectives, broadening the instrument’s techniques and developing the expressive possibilities of the harp. Many works, some of which are for the solo harp, are the fruit of an encounter between artists: Francis Pierre with Luciano Berio, Betsy Jolas, Antoine Tisné, Édith Lejet, Ichiro Nodaïra, and Tôn-Thât Tiêt; Sylvie Beltrando with Yoshihisa Taïra and Gilles Carré; Brigitte Sylvestre with Carlos Roqué Alsina, Georges Aperghis, Marie-Hélène Fournier, and Vinko Globokar; Ursula and Heinz Holliger; Hélène Breschand with Sylvain Kassap, Georgia Spiropoulos, and François Rossé; Isabelle Moretti with Michèle Reverdy; and so on. We must not neglect the role of harpists within established ensembles—for example, the distinguished Marie-Claire Jamet and Frédérique Cambreling with the Ensemble Intercontemporain. We also must underline the work of harp makers and the technological progress culminating in the electric harp and the MIDI (Musical Instrument Digital Interface) harp. All the preceding elements are found in various musical worlds that, although diverse, encourage their inhabitants to mingle and exchange experiences. It is such interactions that allow the instrument, and our attitudes toward it to evolve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("New virtuosities have appeared with the use of numerous playing modes, a highly refined palette of sounds, and different tessituras. There has been a search for sounds that are different and not necessarily pleasing to the ear, an investigation of each component of the instrument, and an exploration of how gestures, theatrical or otherwise, might be used.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collaboration between composers and performers must also affect notation; each composer creates his or her own type of graphics, possibly suggested by the harpist he or she has been working with.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The path followed throughout the twentieth and twenty-first centuries is part of the ongoing history of the evolution of the harp. Before Carlos Salzedo, who had considerably developed the techniques of playing the harp, other stages were decisive for the development of the harp:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  In 1810, the double-action pedal mechanism was invented by Sébastien Érard.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  From the late eighteenth century on, harpists were inventive in exploring different playing techniques. Particularly significant is the manual for harp by Madame de Genlis that was published in 1811."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_4",
      "id": "fn_4"
    }
  }, [_vm._v("4")])]), _vm._v(" It details the search for several harmonics on the same string and the use of pedal glissandi, the fifth finger, and the bow.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  In the early nineteenth century, the virtuoso Elias Parish-Alvars made significant contributions in his playing and works.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("•  In 1832, the harp appeared in Hector Berlioz’s "), _c('i', [_vm._v("Symphonie fantastique")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("•  In 1908, André Caplet wrote the first version of his astonishingly modern score "), _c('i', [_vm._v("Le Masque de la Mort Rouge (The Masque of the Red Death)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("•  In 1915, Claude Debussy wrote the "), _c('i', [_vm._v("Sonata for Flute, Viola and Harp")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Each step taken is more interesting when considered in its capacity to further develop music rather than breaking away from its past. As Jorge Louis Borgès states, “Every writer creates his own precursors. His work modifies our conception of the past, as it will modify the future!”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_5",
      "id": "fn_5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to our broader knowledge of the harp and its present-day compositions, we may look at former works with a fresh eye and continue our voyage of discovery. We might also follow Alban Berg’s advice “to play contemporary works as if they were classical ones, and the latter like the former.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With this book, we aim to make an inventory of the different timbres, effects, and playing modes written for the harp, together with the appropriate notations and graphics, to better to open up the field of today’s and tomorrow’s music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It goes without saying that this panorama is not exhaustive. Choices have had to be made. Indeed, certain effects have given rise to multiple graphic translations from one composer to another, and it seemed inadvisable to retain all of them; the most efficient ones have been selected. We have paid the most attention to what we deemed the most seminal reference books concerning contemporary composition.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Jean-Yves Bosseur stresses the fact that “most non-conventional effects have given rise to multiple graphic variants for reasons which cannot always be separated from a specific artistic purpose.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn_6",
      "id": "fn_6"
    }
  }, [_vm._v("6")])]), _vm._v(" Thus, there will always be several ways to notate the same sound, according to the context, and the universe and style of the composer.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_1",
      "id": "rfn_1"
    }
  }, [_vm._v("1")]), _vm._v(". Karlheinz Stockhausen, in radio interview conducted by Cécile Gilly in February 1996 during rehearsals for "), _c('i', [_vm._v("Vendredi de Lumière (Friday of Light)")]), _vm._v(" in Leipzig, broadcast from July 28 to August 2, 1996, in the “Nocturne” series on France-Culture.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_2",
      "id": "rfn_2"
    }
  }, [_vm._v("2")]), _vm._v(". Ivanka Stoïanova, "), _c('i', [_vm._v("Luciano Berio: Chemins en Musique")]), _vm._v(" [Luciano Berio: musical paths], no. 375–77 (Paris: La Revue Musicale, 1985), 401.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_3",
      "id": "rfn_3"
    }
  }, [_vm._v("3")]), _vm._v(". Ivane Béatrice Bellocq, conversation with the authors, May 31, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_4",
      "id": "rfn_4"
    }
  }, [_vm._v("4")]), _vm._v(". Genlis, Stéphanie Félicité, Comtesse de, "), _c('i', [_vm._v("Nouvelle méthode pour apprendre à jouer de la harpe")]), _vm._v(" [New method for learning to play the harp] (1811; repr. Geneva: Minkoff, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_5",
      "id": "rfn_5"
    }
  }, [_vm._v("5")]), _vm._v(". Jorge Luis Borgès, "), _c('i', [_vm._v("Enquêtes")]), _vm._v(" [Inquiries] (Paris: Gallimard, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_6",
      "id": "rfn_6"
    }
  }, [_vm._v("6")]), _vm._v(". Jean-Yves Bosseur, "), _c('i', [_vm._v("Du son au signe: histoire de la notation musicale")]), _vm._v(" [From sound to sign: history of musical notation] (Paris: Alternatives, 2005).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7480d7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Introduction.vue
// module id = 81
// module chunks = 0